export default {
    'component.shared.countrySelect.placeholder': 'Lütfen bir ülke seçin.',
    'component.shared.centralExamTypeSelect.placeholder': 'Merkezi Sınav Türünü Seçin.',
    'component.shared.institutionSelect.placeholder': 'Kurumu Seçin.',
    'component.shared.departmentsOfUnitSelect.placeholder': 'Bölümü Seçin.',
    'component.shared.unitSelect.placeholder': 'Birimi Seçin.',
    'component.shared.majorScienceBranchOfDepartmentSelect.placeholder': 'Ana Bilim Dalını Seçin.',
    'component.ui.infiniteSearchSelect.loading': 'Yükleniyor...',
    'component.shared.studentLevelSelect.placeholder': 'Lütfen bir seviye seçin.',
    'component.shared.documentTypeSelect.placeholder': 'Lütfen bir belge türü seçin.',
    'component.image.preview': 'Önizleme',
    'component.shared.academicSeasonSelect.placeholder': 'Lütfen bir akademik dönem seçin.',
    'component.shared.applicationStatusSelect.options.applicationNotSubmitted': 'Başvuru gönderilmedi (1)',
    'component.shared.applicationStatusSelect.options.pendingApproval': 'Başvuru gönderildi, incelemeye alındı (2) ',
    'component.shared.applicationStatusSelect.options.applicationAccepted': 'Kabul komisyonuna iletildi (3)',
    'component.shared.applicationStatusSelect.options.applicationNotAccepted': 'Başvuru bilgi / belgeleri eksiktir (4)',
    'component.shared.applicationStatusSelect.options.studentAccepted': 'Onaylandı(Lisans Öğr.ise Mali İşler\'e iletildi)(5)',
    'component.shared.applicationStatusSelect.options.noStudentAccepted': 'Başvuru kabul edilmedi (6)',
    'component.shared.applicationStatusSelect.options.earlyPaymentReceived': 'Ön Ödeme Yapıldı (7)',
    'component.reCaptcha.error': 'Lütfen reCAPTCHA doğrulamasını tamamlayın.',
};
